import { createApp } from 'vue';
import 'vuetify/styles'; // Import Vuetify styles
import router from './router';
import vuetify from './plugins/vuetify';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale);
import '@mdi/font/css/materialdesignicons.css'; // Import Material Design Icons (optional)
//import { useAuthStore } from '@/stores/auth.js';


const pinia = createPinia();
const head = createHead()

const url = window.location.href;
let App;
console.log('url',url.includes.toString().toLowerCase());
console.log('url',url.toString().toLowerCase());
if (url.toString().toLowerCase().indexOf('ahmaydashboard3')!=-1) {

  /* this works
  const urlParts = url.split('/');
  const ahmayIndex = urlParts.findIndex(part => 
    part.toLowerCase() === 'ahmaydashboard3'
  );
  
  const params = {
    name: urlParts[ahmayIndex + 1] || 'M2',
    secs: parseInt(urlParts[ahmayIndex + 2]) || 5
  };
  */
  const urlParams = new URLSearchParams(window.location.search);
  const params = {
    name: urlParams.get('name') || 'M2',
    secs: parseInt(urlParams.get('secs')) || 5
  };
  
  console.log('app params:', params);
  
  App = await import('@/views/AhMayDashboard3.vue').then(module => {
    // Create wrapper component to pass props
    return {
      ...module.default,
      props: {
        name: { type: String, default: params.name },
        secs: { type: Number, default: params.secs }
      }
    };
  });
  console.log('Ahmay loaded');

} else if (url.includes('special')) {
    const areaId = url.split('/').pop();
    console.log('app areaId', areaId);
  
    App = await import('@/views/BillboardPub.vue').then(module => module.default);
    console.log('SpecialApp loaded');
} else {
  App = await import('@/App.vue').then(module => module.default);
  //App = await import('@/App1.vue').then(module => module.default);
  console.log('Default App loaded');
}

const app = createApp(App); // Use the dynamically imported component
app.config.globalProperties.$config = window.config;

app
  .use(router)
  .use(vuetify)
  .use(pinia)
  .use(head)
  .mount('#app');
